module.exports = __webpack_public_path__ + "img/placeholderBuilding.133ac504.jpg";